import React from 'react';
import Page from 'src/components/Page';
import Table from 'src/components/Table';

function BankResponseCodesPage() {

    return <Page header="Bank response codes">
        <Table
            headers={['Response Code', 'Bank Response Code', 'Response Text']}
            body={[
                [<code>0</code>, <code>00</code>, 'Approved'],
                [<code>0</code>, <code>08</code>, 'Honour with ID'],
                [<code>0</code>, <code>16</code>, 'Approved, Update Track 3'],
                [<code>1</code>, <code>09</code>, 'Request in progress'],
                [<code>1</code>, <code>10</code>, 'Approved for partial amount'],
                [<code>1</code>, <code>11</code>, 'Approved VIP'],
                [<code>1</code>, <code>12</code>, 'Invalid transaction'],
                [<code>1</code>, <code>13</code>, 'Invalid amount'],
                [<code>1</code>, <code>17</code>, 'Customer cancellation'],
                [<code>1</code>, <code>18</code>, 'Customer dispute'],
                [<code>1</code>, <code>20</code>, 'Invalid response'],
                [<code>1</code>, <code>21</code>, 'No action taken'],
                [<code>1</code>, <code>22</code>, 'Suspected malfunction'],
                [<code>1</code>, <code>23</code>, 'Unacceptable transaction fee'],
                [<code>1</code>, <code>24</code>, 'File update not supported by receiver'],
                [<code>1</code>, <code>26</code>, 'Duplicate file update record, old record replaced'],
                [<code>1</code>, <code>27</code>, 'File update field edit error'],
                [<code>1</code>, <code>28</code>, 'File update file locked out'],
                [<code>1</code>, <code>29</code>, 'File update not successful, contact acquirer'],
                [<code>1</code>, <code>30</code>, 'Format error'],
                [<code>1</code>, <code>32</code>, 'Completed partially'],
                [<code>1</code>, <code>35</code>, 'Card acceptor contact acquirer'],
                [<code>1</code>, <code>37</code>, 'Card acceptor call acquirer security'],
                [<code>1</code>, <code>38</code>, 'Allowable PIN tries exceeded'],
                [<code>1</code>, <code>40</code>, 'Request function not supported'],
                [<code>1</code>, <code>42</code>, 'No universal account'],
                [<code>1</code>, <code>44</code>, 'No investment account'],
                [<code>1</code>, <code>45</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>46</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>47</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>48</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>49</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>50</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>52</code>, 'No cheque account'],
                [<code>1</code>, <code>53</code>, 'No savings account'],
                [<code>1</code>, <code>55</code>, 'Incorrect PIN'],
                [<code>1</code>, <code>56</code>, 'No card record'],
                [<code>1</code>, <code>57</code>, 'Transaction not permitted to cardholder'],
                [<code>1</code>, <code>58</code>, 'Transaction not permitted to acquirer'],
                [<code>1</code>, <code>60</code>, 'Card acceptor contact acquirer'],
                [<code>1</code>, <code>62</code>, 'Restricted card'],
                [<code>1</code>, <code>63</code>, 'Security violation'],
                [<code>1</code>, <code>64</code>, 'Original amount incorrect'],
                [<code>1</code>, <code>66</code>, 'Card acceptor call acquirer\'s security department'],
                [<code>1</code>, <code>67</code>, 'Hard capture (requires that the card be picked up at ATM)'],
                [<code>1</code>, <code>69</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>70</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>71</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>72</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>73</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>74</code>, 'Reserved for ISO use'],
                [<code>1</code>, <code>75</code>, 'Allowable number of PIN tries exceeded'],
                [<code>1</code>, <code>76</code>, 'Reserved for private use'],
                [<code>1</code>, <code>77</code>, 'Reserved for private use'],
                [<code>1</code>, <code>78</code>, 'Reserved for private use'],
                [<code>1</code>, <code>79</code>, 'Life cycle (Mastercard use only)'],
                [<code>1</code>, <code>80</code>, 'Reserved for private use'],
                [<code>1</code>, <code>81</code>, 'Reserved for private use'],
                [<code>1</code>, <code>82</code>, 'Policy (Mastercard use only)'],
                [<code>1</code>, <code>83</code>, 'Fraud/Security (Mastercard use only)'],
                [<code>1</code>, <code>84</code>, 'Reserved for private use'],
                [<code>1</code>, <code>85</code>, 'Reserved for private use'],
                [<code>1</code>, <code>86</code>, 'Reserved for private use'],
                [<code>1</code>, <code>87</code>, 'Reserved for private use'],
                [<code>1</code>, <code>88</code>, 'Reserved for private use'],
                [<code>1</code>, <code>89</code>, 'Reserved for private use'],
                [<code>1</code>, <code>93</code>, 'Transaction cannot be completed, violation of law'],
                [<code>1</code>, <code>94</code>, 'Duplicate transmission'],
                [<code>1</code>, <code>95</code>, 'Reconcile error'],
                [<code>1</code>, <code>96</code>, 'System malfunction'],
                [<code>1</code>, <code>97</code>, 'Advises that reconciliation totals have been reset'],
                [<code>2</code>, <code>01</code>, 'Refer to card issuer'],
                [<code>2</code>, <code>02</code>, 'Refer to card issuer\'s special conditions'],
                [<code>2</code>, <code>03</code>, 'Invalid merchant'],
                [<code>2</code>, <code>04</code>, 'Pick up card'],
                [<code>2</code>, <code>05</code>, 'Do not honor'],
                [<code>2</code>, <code>06</code>, 'Error'],
                [<code>2</code>, <code>07</code>, 'Pick up card, special condition'],
                [<code>2</code>, <code>14</code>, 'Invalid card number'],
                [<code>2</code>, <code>15</code>, 'No such Issuer'],
                [<code>2</code>, <code>19</code>, 'Re-enter transaction'],
                [<code>2</code>, <code>25</code>, 'Unable to locate record on file'],
                [<code>2</code>, <code>31</code>, 'Bank not supported by switch'],
                [<code>2</code>, <code>34</code>, 'Suspected fraud'],
                [<code>2</code>, <code>36</code>, 'Restricted card'],
                [<code>2</code>, <code>39</code>, 'No credit account'],
                [<code>2</code>, <code>41</code>, 'Lost card'],
                [<code>2</code>, <code>43</code>, 'Stolen card, pick up'],
                [<code>2</code>, <code>59</code>, 'Suspected fraud'],
                [<code>2</code>, <code>61</code>, 'Exceeds withdrawal amount limits'],
                [<code>2</code>, <code>65</code>, 'Exceeds withdrawal frequency limit'],
                [<code>2</code>, <code>90</code>, 'Cut-off is in process (switch ending a days business and starting the next. Transaction can be sent again in a few minutes.)'],
                [<code>2</code>, <code>91</code>, 'Issuer or switch inoperative'],
                [<code>2</code>, <code>92</code>, 'Financial institution or intermediate network facility cannot be found for routing'],
                [<code>2</code>, <code>98</code>, 'MAC error'],
                [<code>2</code>, <code>99</code>, 'Reserved for National Use'],
                [<code>3</code>, <code>68</code>, 'Response received too late'],
                [<code>4</code>, <code>33</code>, 'Expired card'],
                [<code>4</code>, <code>54</code>, 'Expired card'],
                [<code>5</code>, <code>51</code>, 'Not sufficient funds'],
                [<code>?</code>, '', 'Response Unknown'],
                [<code>6</code>, '', 'Transaction Declined - Error Communicating with Bank'],
                [<code>7</code>, '', 'Payment Server Processing Error - Typically caused by invalid input data such as an invalid card number. Processing errors can also occur'],
                [<code>8</code>, '', 'Transaction Declined - Transaction Type Not Supported'],
                [<code>9</code>, '', 'Bank Declined Transaction (Do not contact Bank)'],
                [<code>A</code>, '', 'Transaction Aborted'],
                [<code>C</code>, '', 'Transaction Cancelled'],
                [<code>D</code>, '', 'Deferred Transaction'],
                [<code>E</code>, '', 'Issuer Returned a Referral Response'],
                [<code>F</code>, '', '3D Secure Authentication Failed'],
                [<code>I</code>, '', 'Card Security Code Failed'],
                [<code>L</code>, '', 'Shopping Transaction Locked (This indicates that there is another transaction taking place using the same shopping transaction number)'],
                [<code>N</code>, '', 'Cardholder is not enrolled in 3D Secure (Authentication Only)'],
                [<code>P</code>, '', 'Transaction is Pending'],
                [<code>R</code>, '', 'Retry Limits Exceeded, Transaction Not Processed'],
                [<code>S</code>, '', 'Duplicate OrderInfo used. (This is only relevant for Payment Servers that enforce the uniqueness of this field)'],
                [<code>U</code>, '', 'Card Security Code Failed'],
                [<code>PT_E1</code>, '', 'Database error.'],
                [<code>PT_E2</code>, '', 'Unable to encrypt card number.'],
                [<code>PT_E3</code>, '', 'Unable to decrypt card number.'],
                [<code>PT_E4</code>, '', 'Server shutdown in progress.'],
                [<code>PT_E5</code>, '', 'Server busy, transaction timed out in queue and was not sent to the bank.'],
                [<code>PT_E6</code>, '', 'Processing aborted, payment server is shutting down.'],
                [<code>PT_G1</code>, '', 'Gateway configuration error.'],
                [<code>PT_G2</code>, '', 'Unable to build gateway request.'],
                [<code>PT_G3</code>, '', 'Unable to connect to gateway.'],
                [<code>PT_G4</code>, '', 'Unable to send transaction request data.'],
                [<code>PT_G5</code>, '', 'Unable to get response data.'],
                [<code>PT_G6</code>, '', 'Unable to process transaction.'],
                [<code>PT_G7</code>, '', 'Unable to process, server busy.'],
                [<code>PT_G8</code>, '', 'Unable to parse response data.'],
                [<code>PT_G9</code>, '', 'PayPal gateway error.'],
                [<code>PT_G10</code>, '', 'Payment response details not present in PayPal response.'],
                [<code>PT_G11</code>, '', 'PayPal communication error.'],
                [<code>PT_G12</code>, '', 'Gateway error.'],
                [<code>PT_G13</code>, '', 'Message response timeout.'],
                [<code>PT_G14</code>, '', 'Gateway request rejected.'],
                [<code>PT_R1</code>, '', 'Original transaction not found.'],
                [<code>PT_R2</code>, '', 'Original transaction was not approved.'],
                [<code>PT_R3</code>, '', 'Original transaction is locked.'],
                [<code>PT_R4</code>, '', 'Transaction already fully refunded.'],
                [<code>PT_R5</code>, '', 'Only $x.xx available for refund.'],
                [<code>PT_R6</code>, '', 'Preauth transaction already completed.'],
                [<code>PT_R7</code>, '', 'Unable to verify if reversal can be processed.'],
                [<code>PT_R8</code>, '', 'Transaction already reversed.'],
                [<code>PT_R9</code>, '', 'Transaction partially refunded.'],
                [<code>PT_R10</code>, '', '(Only for reversals of timed out transactions) Original transaction not found.'],
                [<code>PT_R11</code>, '', '(Only for reversals of timed out transactions) Multiple instances of original transaction found.'],
                [<code>PT_R12</code>, '', '(Only for reversals of timed out transactions) Original transaction was not successful.'],
                [<code>PT_R13</code>, '', '(Only for reversals of timed out transactions) Original transaction number not found.'],
                [<code>PT_R14</code>, '', '(Only for reversals of timed out transactions) Error looking up result of original transaction.'],
                [<code>PT_R15</code>, '', 'Invalid amount. Reversal amount must be the same as the amount of the original transaction.'],
                [<code>PT_R16</code>, '', 'DE payment already rejected.'],
                [<code>PT_T1</code>, '', 'DVToken payment not allowed for Internet, IVR and call centre transaction types.'],
                [<code>PT_T2</code>, '', 'Card payment details not found for this dvtoken.'],
                [<code>PT_T3</code>, '', 'Unable to decrypt card number.'],
                [<code>PT_T4</code>, '', 'Unable to retrieve card payment details due to system error.'],
                [<code>PT_T5</code>, '', 'DVToken payment not supported.'],
                [<code>PT_T6</code>, '', 'DVToken not yet valid.'],
                [<code>PT_T7</code>, '', 'DVToken expired.'],
                [<code>PT_V1</code>, '', 'Invalid transaction type.'],
                [<code>PT_V2</code>, '', 'Invalid financial type.'],
                [<code>PT_V3</code>, '', 'Invalid amount.'],
                [<code>PT_V4</code>, '', 'Invalid card number.'],
                [<code>PT_V5</code>, '', 'Invalid expiry date.'],
                [<code>PT_V6</code>, '', 'Invalid CVN.'],
                [<code>PT_V7</code>, '', 'Financial transaction type not supported by gateway.'],
                [<code>PT_V8</code>, '', 'Reversal not supported.'],
                [<code>PT_V9</code>, '', 'Merchant/biller details not found.'],
                [<code>PT_V10</code>, '', 'Unable to retrieve merchant/biller details.'],
                [<code>PT_V11</code>, '', 'Cardholder not authenticated (VbV, SecureCode).'],
                [<code>PT_V12</code>, '', 'Error authenticating cardholder (VbV, SecureCode).'],
                [<code>PT_V13</code>, '', 'Invalid BSB number.'],
                [<code>PT_V14</code>, '', 'Invalid account number.'],
                [<code>PT_V15</code>, '', 'Invalid account name.'],
                [<code>PT_V16</code>, '', 'Payment details not provided.'],
                [<code>PT_V17</code>, '', 'No valid DDA found.'],
                [<code>PT_V18</code>, '', 'Payment failed anti fraud rule validation.'],
                [<code>PT_V19</code>, '', 'Refund not allowed, daily refund limit of X reached.'],
                [<code>PT_V20</code>, '', 'Refund not allowed, daily refund amount limit of $x.xx exceeded.'],
                [<code>PT_V21</code>, '', 'Transaction blocked.'],
                [<code>PT_V22</code>, '', 'Invalid payment method. Provided card type is not supported by browser integration.'],
                [<code>PT_V23</code>, '', 'Currency code of refund: X must match currency code of original transaction: Y.']
            ]}
        />

        <h2 id="cvnResponseCodes">CVN response codes</h2>
        <Table
            headers={['Code', 'Description']}
            body={[
                [<code>M</code>, 'Valid or matched CVN.'],
                [<code>S</code>, 'Merchant indicates CVN not present on card.'],
                [<code>P</code>, 'CVN Not Processed.'],
                [<code>U</code>, 'Card issuer is not registered and/or certified.'],
                [<code>N</code>, 'Code invalid or not matched.'],
                [<code>Unsupported</code>, 'Acquiring institution does not support CVN.'],
            ]}
        />
    </Page>;
}

export default BankResponseCodesPage;